import {
    getDeliveryMethodDropdown,
    getParkingStatusDropdown,
} from 'api/backoffice/dropdownOptions/dropdownOptions.api';
import type { ParkingStatusDropdownRequest } from 'api/backoffice/dropdownOptions/dropdownOptions.types';

export const backofficeDropdownOptionsAPI = {
    getParkingStatusDropdown,
    getDeliveryMethodDropdown,
};

export const dropdownOptionsKeys = {
    all: ['dropdownOptions'] as const,
    parkingStatusDropdown: (req?: ParkingStatusDropdownRequest) =>
        [...dropdownOptionsKeys.all, 'parkingStatusDropdown', req] as const,
    deliveryMethodDropdown: () =>
        [...dropdownOptionsKeys.all, 'deliveryMethodDropdown'] as const,
};
